var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomReset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.97449 3.73282C9.04912 3.73282 8.21071 3.87426 7.45704 4.10035C7.05008 4.22245 6.62128 3.99155 6.49919 3.58462C6.37709 3.1777 6.60805 2.74886 7.01494 2.62678C7.90234 2.36057 8.88955 2.19434 9.97449 2.19434C14.9264 2.19434 18.9489 6.17355 18.9489 11.097C18.9489 16.0205 14.9264 19.9997 9.97449 19.9997C5.02255 19.9997 1 16.0205 1 11.097C1 9.26589 1.56203 7.55799 2.51614 6.1437C2.75373 5.79151 3.23185 5.69859 3.58404 5.93619C3.9362 6.17379 4.02912 6.65189 3.79155 7.00408C3.00205 8.17437 2.53848 9.58454 2.53848 11.097C2.53848 15.1583 5.85961 18.4612 9.97449 18.4612C14.0893 18.4612 17.4105 15.1583 17.4105 11.097C17.4105 7.03577 14.0893 3.73282 9.97449 3.73282Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.11018 0.123967C9.46656 0.355163 9.5681 0.83152 9.33689 1.18794L8.03392 3.19675L10.0618 4.50206C10.419 4.73197 10.5221 5.20797 10.2922 5.56521C10.0623 5.92244 9.58625 6.02564 9.22908 5.79567L6.55212 4.07257C6.38018 3.96193 6.25938 3.78734 6.21643 3.58742C6.17341 3.38751 6.21181 3.17871 6.32307 3.00716L8.04617 0.35072C8.27737 -0.00570887 8.75375 -0.107224 9.11018 0.123967Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomReset);
export default __webpack_public_path__ + "static/media/zoomReset.ae74fec93ec9d897bd31fd5c0385ffd1.svg";
export { ForwardRef as ReactComponent };